module.exports = __webpack_public_path__ + "static/media/calibration_step2_adjust.d1c261f2.gif";